import axios from "axios"
const baseUrl = process.env.REACT_APP_API_BASEURL

/**
    * @function dimensionListService
    * @param ({ authToken, filter, limit, offset })
    * @description call API to get the dimension list
*/
export const dimensionListService = async ({ authToken, filter, limit, offset }) => {
    try {
        console.log('[DimensionService] Making API call to:', `${baseUrl}dimension`);
        console.log('[DimensionService] With params:', { offset, limit, filter });
        console.log('[DimensionService] Auth token present:', !!authToken);
        
        const result = await axios.get(`${baseUrl}dimension?offset=${offset}&limit=${limit}&filter=${filter}`, {
            headers: {
                Authorization: `Bearer ${authToken}`
            }
        });
        
        console.log('[DimensionService] API Response:', {
            status: result.status,
            statusText: result.statusText,
            hasData: !!result.data,
            dataLength: result.data?.data?.list?.length
        });
        
        return result;
    } catch (error) {
        console.error('[DimensionService] API Error:', {
            message: error.message,
            response: error.response?.data,
            status: error.response?.status,
            config: {
                url: error.config?.url,
                method: error.config?.method,
                headers: error.config?.headers
            }
        });
        throw error;
    }
}

/**
    * @function progressDimensionListService
    * @param ({ authToken, submissionId, filter, limit, offset })
    * @description call API to get the progress dimension list
*/
export const progressDimensionListService = async ({ authToken, submissionId, filter, limit, offset }) => {
    try {
        console.log('[ProgressDimensionService] Making API call to:', `${baseUrl}ProGress-dimension/list`);
        console.log('[ProgressDimensionService] With params:', { submissionId, offset, limit, filter });
        console.log('[ProgressDimensionService] Auth token present:', !!authToken);
        
        const result = await axios.get(`${baseUrl}ProGress-dimension/list`, {
            params: {
                submissionId,
                offset,
                limit,
                filter
            },
            headers: {
                Authorization: `Bearer ${authToken}`
            }
        });
        
        console.log('[ProgressDimensionService] API Response:', {
            status: result.status,
            statusText: result.statusText,
            hasData: !!result.data,
            dataLength: result.data?.data?.list?.length
        });
        
        return result;
    } catch (error) {
        console.error('[ProgressDimensionService] API Error:', error);
        throw error;
    }
}

/**
    * @function getActiveDimensionListService
    * @param ({ authToken })
    * @description call API to get the active dimension list
*/
export const getActiveDimensionListService = async ({ authToken }) => {
    try {
        console.log('[ActiveDimensionService] Making API call to:', `${baseUrl}dimension?filter=Active`);
        console.log('[ActiveDimensionService] Auth token present:', !!authToken);
        
        const result = await axios.get(`${baseUrl}dimension?filter=Active`, {
            headers: {
                Authorization: `Bearer ${authToken}`
            }
        });
        
        console.log('[ActiveDimensionService] API Response:', {
            status: result.status,
            statusText: result.statusText,
            hasData: !!result.data,
            dataLength: result.data?.data?.list?.length
        });
        
        return result;
    } catch (error) {
        console.error('[ActiveDimensionService] API Error:', {
            message: error.message,
            response: error.response?.data,
            status: error.response?.status,
            config: {
                url: error.config?.url,
                method: error.config?.method,
                headers: error.config?.headers
            }
        });
        throw error;
    }
};

/**
    * @function getActiveProgressDimensionListService
    * @param ({ authToken })
    * @description call API to get the active progress dimension list
*/
export const getActiveProgressDimensionListService = async ({ authToken }) => {
    try {
        console.log('[ActiveProgressDimensionService] Making API call to:', `${baseUrl}ProGress-dimension/list?filter=Active`);
        console.log('[ActiveProgressDimensionService] Auth token present:', !!authToken);
        
        const result = await axios.get(`${baseUrl}ProGress-dimension/list?filter=Active`, {
            headers: {
                Authorization: `Bearer ${authToken}`
            }
        });
        
        console.log('[ActiveProgressDimensionService] API Response:', {
            status: result.status,
            statusText: result.statusText,
            hasData: !!result.data,
            dataLength: result.data?.data?.list?.length
        });
        
        return result;
    } catch (error) {
        console.error('[ActiveProgressDimensionService] API Error:', {
            message: error.message,
            response: error.response?.data,
            status: error.response?.status,
            config: {
                url: error.config?.url,
                method: error.config?.method,
                headers: error.config?.headers
            }
        });
        throw error;
    }
};
